import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-input-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode(" Kod pocztowy "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}

import { computed } from 'vue';
import { useField, Field } from 'vee-validate';


export default {
  __name: 'ZipCodeField',
  setup(__props) {

const { value: zipCode, errors, errorMessage } = useField('personalInformation.zipCode');

const formattedZipCode = computed({
    get: () => zipCode.value,
    set: (newVal) => {
        let numericValue = newVal.replace(/\D/g, '').slice(0, 5);
        if (numericValue.length >= 2) {
            numericValue = `${numericValue.slice(0, 2)}-${numericValue.slice(2)}`;
        }
        zipCode.value = numericValue;
    },
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(Field), {
      class: _normalizeClass(["form-input form-input--zipcode", {
                'border-[1px] !border-error border-solid': _unref(errors).length,
                'border-none': !_unref(errors).length,
            }]),
      placeholder: "__-___",
      type: "text",
      name: "zipCode",
      modelValue: _unref(formattedZipCode),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(formattedZipCode) ? (formattedZipCode).value = $event : null)),
      maxlength: "6"
    }, null, 8, ["class", "modelValue"]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}